<template>
  <b-modal id="modelAddAccount"
           size="lg"
           title = "Create A New Account"
           @ok = "create"
  >
    Please Enter New Account Name
    <b-form-input v-model ="name"></b-form-input>
  </b-modal>
</template>

<script>
  import notification from '@/components/common/notification'
  export default {
    data () {
      return {
        name: ''
      }
    },
    methods: {
      create (evt) {
        evt.preventDefault()
        if (this.name.length === 0) {
          notification.notice('warning', 'Please Enter Account Name!')
          return
        }
        this.$http.post('LandingPage.aspx/CreateAccount', {
          AccountName: this.name
        }).then(resp => {
          if (resp.body.d.DataSource) {
            notification.notice('success', 'Create successfully')
            this.$nextTick(() => {
              this.$root.$emit('bv::hide::modal', 'modelAddAccount')
            })
            this.$store.dispatch('user/getUserInit')
          }
        }, resp => {
          notification.notice('error', 'Failed to Create Account , please try again')
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/landings/MModalCreateAccount.vue